import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../../context/auth";
import {logout} from "../../services/auth-service";
import React, {useRef, useState} from "react";
import {AppRoutes} from "../../utils/constants";
import UserAvatar from "../../components/user-avatar";
import HelperService from "../../services/helper-service";
import detectOutsideClickHook from "../../utils/detectOutsideClick.hook";

function NavbarProfile(props) {

  const navigate = useNavigate();
  const auth = useAuth();
  const [collapsed, setCollapsed] = useState(true);

  const navProfileMenu = useRef(null);
  detectOutsideClickHook(navProfileMenu, ()=>{setCollapsed(true)});

  const doLogout = ()=>{
    logout().finally(()=>{
      auth.doLogout();
      navigate(AppRoutes.landing.path);
    })
  };

  return (
    <div ref={navProfileMenu}>
      <a className="nav-link dropdown-toggle nav-user arrow-none me-0"
         id="topbar-userdrop"
         role="button"
         aria-haspopup="true"
         aria-expanded={!!collapsed}
         onClick={(event)=>setCollapsed(!collapsed)}
         style={{"color": "#cddee7"}}>
        <span className="account-user-avatar">
          {auth.currentUser ? <UserAvatar user={auth.currentUser} /> :
            <span className={"bg-white rounded-circle p-1 d-flex align-items-center justify-content-center"} style={{"width":"30px", "height":"30px", "overflow": "hidden"}}>
            <span className="dripicons-user text-dark" style={{"fontSize": "25px", "position": "relative"}}></span>
          </span>}
        </span>
        <span>
          <span className="account-user-name">{auth.currentUser?.name}</span>
          <span className="account-position">{auth.currentUser?.global_roles && auth.currentUser?.global_roles[0] ? auth.currentUser?.global_roles[0].title : ''}</span>
        </span>
      </a>
      <div className={`dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown ${collapsed ? '' : ' show' }`} aria-labelledby="topbar-userdrop">
        {auth.currentUser?.user_groups && auth.currentUser.user_groups?.length>0 && <>{auth.currentUser.user_groups.map((ug)=>{
          return !ug.users ? '' : <div key={ug.id}>
            <div className="dropdown-header noti-title">
              <h6 className="text-overflow m-0" title={ug.title}>Pridružené kontá</h6>
            </div>
            {ug.users.map((u)=>{
              return <div key={u.id} onClick={()=>auth.toggleDisplayUser(u.id)} className="clickable nav-link dropdown-toggle nav-user arrow-none text-dark" style={{"backgroundColor": "#fff", "border": "none"}}>
                <span className="account-user-avatar">
                    {!auth.displayUsers?.includes(u.id) && <span className="mdi mdi-checkbox-blank-circle-outline text-muted account-user-checkbox"></span>}
                    {auth.displayUsers?.includes(u.id) && <span className="mdi mdi-checkbox-marked-circle-outline text-success account-user-checkbox"></span>}
                    <UserAvatar user={u} />
                  </span>
                      <span>
                    <span className="account-user-name">{u.name}</span>
                    <span className="account-position">{HelperService.getObjByKey(ug.roles, 'id', u.pivot.role_id)?.title}</span>
                  </span>
                </div>
            })}
            <hr />
          </div>
        })}
        </>}
        <Link to={AppRoutes.profile.path} className="dropdown-item notify-item" onClick={()=>setCollapsed(!collapsed)}>
          <i className="mdi mdi-account-circle me-1"></i>
          <span>Môj účet</span>
        </Link>

        {/*<a href="javascript:void(0);" className="dropdown-item notify-item">*/}
        {/*  <i className="mdi mdi-account-edit me-1"></i>*/}
        {/*  <span>Nastavenia</span>*/}
        {/*</a>*/}

        <span className="dropdown-item notify-item clickable" onClick={()=>{setCollapsed(!collapsed); doLogout()}}>
          <i className="mdi mdi-logout me-1"></i>
          <span>Odhlásenie</span>
        </span>

      </div>
    </div>
  );
}

export default NavbarProfile
